import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  container: {
    paddingVertical:12,
    marginTop: 20,
    width: 350,
    justifyContent: 'center',
    alignItems: "center",
    alignSelf: "center",
    borderRadius: 8,
    borderColor: "#077A97",
    borderWidth: 0.5,
    shadowColor: "#000",
        shadowOffset: {
        width: 0,
        height: 4,
        },
        shadowOpacity: 0.25,
        shadowRadius: 4.84,
        elevation: 4
  },
  contentBtns: {
    width: 340,
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    alignSelf: 'center'
  },
  btn: {
    fontFamily: 'Poppins, sans-serif',
    padding: 10,
    width: 120,
    height: 38,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 4,
    backgroundColor: "#077A97",
    marginVertical: 12,
    alignSelf: 'center',
    color: '#fff',
  },
  descriptionPerfil: {
    marginTop: 7,
    width: '100%',
    fontSize: 20,
    textAlign: 'center',
  },
  perfil: {
    fontWeight: 'bold',
    marginTop: 40,
    fontSize: 40,
    textAlign: 'center',
    color: 'green'
  },
  containerPerfil: {
    flex: 0.5,
    paddingHorizontal: 25,
    justifyContent: 'center'
  },
  textBtn: {
    textTransform: 'uppercase',
    textAlign: 'center',
    color: '#fff'
  },
  description: {
    marginTop: 7,
    
  },
  contentRadioButton: {
    flexDirection: 'row'
  },
  titleStep: {
    textAlign: 'center',
    fontWeight: 'bold',
    fontSize: 14,
    marginBottom: 25
  }
});

export default styles;
